import { render, staticRenderFns } from "./ContactConversationFiles.vue?vue&type=template&id=210a5623&scoped=true&"
import script from "./ContactConversationFiles.vue?vue&type=script&lang=js&"
export * from "./ContactConversationFiles.vue?vue&type=script&lang=js&"
import style0 from "./ContactConversationFiles.vue?vue&type=style&index=0&id=210a5623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a5623",
  null
  
)

export default component.exports